// src/footerConfigs.js

export const footerConfigs = {
  "bheema": {
 brandName: "Kavya Eng Medium School,Sindgi",
     contact: "+91 9980096180,9845134180 |  kvyasklsindagi@email.com",
     socialLinks: {
       instagram: "https://www.instagram.com/p/DZu2Vt2Na3W/",
       whatsapp:   "https://wa.me/yourwhatsapplink",
       youtube:    "https://www.youtube.com/@kavyaenglishmediumhps1324",
       facebook:   "https://www.facebook.com/reel/525657073130207",
       twitter:    "https://twitter.com"
    }
  },

  "acmeCorp": {
    brandName: "ACME Corporation",
    contact: "1800-ACME | support@acme.com",
    socialLinks: {
      instagram: "https://instagram.com/acmecorp",
      whatsapp:   "",
      youtube:    "https://youtube.com/acmecorp",
      facebook:   "https://facebook.com/acmecorp",
      twitter:    "https://twitter.com/acmecorp"
    }
  }

  // add more customer configs here...
};
